<template>
    <path d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z"/>
</template>

<script>
    export default {
        name: 'ArrowUp',
    }
</script>



// WEBPACK FOOTER //
// src/components/icon/ArrowUp.vue